import React from 'react';
import { DomainReportsHubPage } from '@/reports/components/DomainReportsHubPage';
import type { ReportModuleKey } from '@/reports/types';

export function makeDomainReportsHub(module: ReportModuleKey): React.FC {
  const Page: React.FC = () => <DomainReportsHubPage module={module} />;
  Page.displayName = `DomainReportsHub_${module}`;
  return Page;
}

export const ScmReportsHubPage = makeDomainReportsHub('scm');
export const SalesReportsHubPage = makeDomainReportsHub('sales');
export const FinReportsHubAliasPage = makeDomainReportsHub('fin');
export const MfgReportsHubPage = makeDomainReportsHub('mfg');
export const QmsReportsHubPage = makeDomainReportsHub('qms');
export const PrjReportsHubPage = makeDomainReportsHub('prj');
export const EpcReportsHubPage = makeDomainReportsHub('epc');
export const AssetReportsHubPage = makeDomainReportsHub('asset');
export const HrReportsHubPage = makeDomainReportsHub('hr');
export const EduReportsHubPage = makeDomainReportsHub('education');
